import React from "react"
import { Edit } from "react-admin"
import { usePermissions } from "ra-core"
import { RecordActionsTabs } from "components/ui/layouts"
import Form from "./form"


function UserEdit(props: React.PropsWithChildren): JSX.Element  {
    const { permissions } = usePermissions()

    return (
        <Edit redirect="show" mutationMode="pessimistic" actions={<RecordActionsTabs />}>
            <Form />
        </Edit>
    )
}

export default UserEdit
